module.exports = __webpack_public_path__ + "media/images/game/zs_2019/fin_gram-694788f92477c5dc8188ed4f5155effc.png";